export type FilterTitleProps = {
    title: string;
    additionalClasses?: string;
}

const FilterTitle = ({title, additionalClasses=""} : FilterTitleProps) => <h5 className={`subtle ${additionalClasses}`}>{title}</h5>;

export default FilterTitle;